<template>
    <div>
        {{ vatText }}
    </div>
</template>

<script setup lang="ts">

import {computed} from 'vue'
import {useCachedT} from '@/services/useCachedI18n'
import {ExtendedVatEntry} from '@/vat/types/ExtendedVatReport'

const props = defineProps({
    params: {
        required: true,
        type: Object as () => {
            data: ExtendedVatEntry,
            context: {
                panelId: Number
            }
        }
    }
})

const { cachedT } = useCachedT ()

const vatText = computed(() => {
    let text = props.params.data.code + ' ' + cachedT('vat-codes.' + props.params.data.code)
    if (props.params.data.specificationKey) {
        text += ' - ' + cachedT('vat-codes.' + props.params.data.specificationKey)
    }
    return text
})

</script>

<style scoped>

</style>